
export { VerticalLayout } from "/home/runner/work/mangomap/mangomap/packages/ui-components/src/components/organisms/vertical-layout/index.tsx"